// Variables that are constants and that should be used later on
// By simply changing the data here, it allows us to configure easily

export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SECONDS = 10;
export const RES_PER__PAGE = 10;
export const API_KEY = `1bf7b1f4-5f9f-491c-a7b2-b79872ddd785`;
export const MODAL_CLOSE_SECONDS = 2.5;
